import { p as r, c as a } from "../../styled-components.browser.esm-DBaC0ZEI.mjs";
import { Tags as o } from "../Tag/AntTag.js";
const i = r(o)`
  ${({
  cssvars: t
}) => t && `
      --tagBg: ${t.tagBg || "var(--tagBg)"};
      --tagText: ${t.tagText || "var(--tagText)"};
    `}
  padding: var(--space-4) var(--space-8) !important;
  border-radius: var(--br-2) !important;
  border-color: var(--tagBorder) !important;
  color: var(--tagText) !important;
  background-color: var(--tagBg) !important;
  font-weight: var(--fs-regular) !important;
  font-size: var(--fs-12);
  line-height: 1.2;
  border: 0;

  ${({
  break: t
}) => t === "break-1" && a`
      height: 36px !important;
      width: 85px !important;
      white-space: break-spaces !important;
      line-height: var(--fs-14) !important;
    `}

  ${({
  noBg: t
}) => t === "no-Bg" && a`
      padding: 0 !important;
      font-size: var(--fs-14);
    `}
`;
export {
  i as default
};
//# sourceMappingURL=style.js.map
